/*
 * @Author: Duanjiaojiao
 * @Date: 2022-07-05 14:06:50
 * @LastEditors: Duanjiaojiao
 * @LastEditTime: 2022-07-06 16:15:27
 * @Description:
 * @FilePath: /BM-Main/src/router/new-media.js
 * @props:
 */
import Layout from '@src/Layout'

export default {
  path: '/new-media',
  component: Layout,
  children: [
    {
      path: 'lottery-index',
      name: 'lottery-index',
      meta: {
        title: '电池健康度查询',
        pageId: 'U1459', // 将作为页面埋点的 actionType
        level: 2
      },
      component: () => import(/* webpackChunkName: "lottery-index" */ 'app/new-media/lottery/index.vue')
    },
    {
      path: 'lottery-select',
      name: 'lottery-select',
      meta: {
        title: '电池健康度查询',
        pageId: 'E1888', // 将作为页面埋点的 actionType
        level: 2
      },
      component: () => import(/* webpackChunkName: "lottery-select" */ 'app/new-media/lottery/select.vue')
    },
    {
      path: 'lottery-report',
      name: 'lottery-report',
      meta: {
        title: '电池健康度查询',
        pageId: 'O8800', // 将作为页面埋点的 actionType
        level: 2
      },
      component: () => import(/* webpackChunkName: "lottery-report" */ 'app/new-media/lottery/report.vue')
    }
  ]
}
